var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"col-md-6 paymethod\" ng-repeat=\"method in methods\" ng-disabled=\"selected === $index\" ng-click=\"$ctrl.select($index)\"> <div ng-if=\"method.InternalName=='VM'\" style=\"background-image: url('{{ bgImagePaytraylVerkkoPankki }}')\" class=\"col-md-6 paymethodimage\"> </div> <div ng-if=\"method.InternalName=='VMLK'\" style=\"background-image: url('{{ bgImagePaytraylLuottokortit }}')\" class=\"col-md-6 paymethodimage\"> </div> <div class=\"col-md-6 paymethodname\"> <strong>{{ method.Name }}</strong> <p ng-if=\"method.Fee > 0\">{{ 'omaloma.payment.payment_method_fee' || i18next }} {{ method.Fee }} €</p> </div> </div>  </web-component>";
var id1="winresOmalomaPayMethodPicker.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaPayMethodPicker/winresOmalomaPayMethodPicker.html
// module id = 354
// module chunks = 2